<template>
<div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>商户订单</el-breadcrumb-item>
    <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--搜索栏区域-->
    <el-row :gutter="20" class="search">
        <el-col :span="11">
        <el-select v-model="shopId" placeholder="请选择店铺">
            <el-option v-for="item in shopNameList" :key="item.id" :label="item.shopName" :value="item.id"></el-option>
        </el-select>
        <el-button icon="el-icon-search" @click="searchList">搜索</el-button>
        </el-col>
    </el-row>
    <!-- <br>
    <el-row :gutter="20" class="search">
        <el-col :span="11">
            <el-select v-model="id" placeholder="请选择您的收货地址">
                <el-option v-for="item in addressList" :key="item.id" :label="item.id" :value="item.id"></el-option>
            </el-select>
            <el-button icon="el-icon-search" @click="searchAddressList">搜索</el-button>
        </el-col>
    </el-row> -->
    <el-button type="primary" @click="dialogTableVisible = true">请选择发货地址</el-button>
    <el-dialog title="请选择发货地址" :visible.sync="dialogTableVisible" :before-close="handleClose"  width="90%">
        <!-- 表格区域 -->
        <el-table class="address-list" :data="addressList.slice((currentPage-1) * pageSize,currentPage * pageSize)" stripe border>
        <el-table-column prop="id" label="地址编号" align="center"></el-table-column>
        <el-table-column prop="userId" label="商家用户名" align="center"></el-table-column>
        <el-table-column prop="receiverName" label="商家名" align="center"></el-table-column>
        <el-table-column prop="receiverPhone" label="商家电话" align="center"></el-table-column>
        <el-table-column prop="receiverProvince" label="商家省份" align="center"></el-table-column>
        <el-table-column prop="receiverCity" label="商家城市" align="center"></el-table-column>
        <el-table-column prop="receiverDistrict" label="商家地区" align="center"></el-table-column>
        <el-table-column prop="receiverAddress" label="商家详细地址" align="center"></el-table-column>
        <el-table-column label="设为默认地址" align="center">
            <template >
                <el-switch
                v-model="value"
                active-color="#13ce66"
                inactive-color="#ff4949">
                </el-switch>
            </template>
        </el-table-column>
        </el-table>
            <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
            </span>
        <!-- </template> -->
    </el-dialog>

    <br>
    <br>
    <!--订单列表表格部分-->
    <el-table :data="tableData.slice((currentPage-1) * pageSize,currentPage * pageSize)" border stripe style="width: 100%">
    <el-table-column prop="orderNo" label="订单编号" align="center"></el-table-column>
    <el-table-column prop="createTime" label="订单创建时间" :formatter="dataFormat" align="center"></el-table-column>
    <el-table-column prop="updateTime" label="更新时间" :formatter="dataFormat" align="center"></el-table-column>
    <el-table-column prop="postage" label="运费" align="center"></el-table-column>
    <el-table-column prop="userName" label="用户名" align="center"></el-table-column>
    <el-table-column prop="discount" label="优惠金额(元)" align="center"></el-table-column>
    <el-table-column prop="payment" label="实际付款金额(元)" align="center"></el-table-column>
    <!-- <el-table-column prop="shippingId" label="收货地址id" align="center"></el-table-column> -->
    <el-table-column prop="status" label="订单状态" align="center">
        <!--上下架状态切换-->
        <!--订单状态显示,可以通过color指定标签的颜色,后面更改-->
        <template scope="scope">
        <el-button v-if="scope.row.status === -1" type="danger" effect="dark" disabled size="medium">已取消</el-button>
        <el-button v-if="scope.row.status === 0" type="warning" effect="dark" disabled size="medium">待付款</el-button>
        <el-button v-if="scope.row.status === 1" type="info" effect="dark" @click="orderStatusChange(scope.row)" size="medium">待发货</el-button>
        <el-button v-if="scope.row.status === 2" type="primary" effect="dark"  disabled size="medium">待收货</el-button>
        <el-button v-if="scope.row.status === 3" type="success" effect="dark"  disabled size="medium">交易成功</el-button>
        <el-button v-if="scope.row.status === 4"  effect="dark" disabled size="medium">售后处理</el-button>
        </template>
    </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background
                layout="prev, pager, next"
                :total="tableData.length"
                :current-page="currentPage"
                :page-size="pageSize"
                style="text-align: center;margin-top: 10px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPage"
                >
    </el-pagination>
</div>
</template>

<script>
import request from '../http/shop'
export default {
    name: 'addressList',
    mounted () {
    this.getAddressList()
},
data () {
    return {
    value: false,
      tableData: [], /* 表格商品列表数据 */
      currentPage: 1, // 初始页
      pageSize: 6, //    每页的数据
    shopNameList: [],
      addressList: [], // 用户地址列表
      shopId: '', // 店铺名对应id
    pages: '',
    limit: '',
    // gridData: [{
    //     id: '', // 商家编号
    //     receiverName: '', // 商家名
    //     receiverPhone: '', // 商家电话
    //     receiverProvince: '', // 商家所在省份
    //     receiverCity: '', // 商家所在城市
    //     receiverDistrict: '', // 商家所在区县
    //     receiverAddress: '' // 商家详细地址
    //     }],
        dialogTableVisible: false,
        dialogVisible: false
    }
},
methods: {
    // props: {
    // Visible: {
    //     type: Boolean,
    //     default: false
    // }
    // },
    handleClose (done) {
        this.$confirm('确认关闭？')
        .then(_ => {
            done()
        })
        .catch(_ => {})
    },
//     computed: {
//     dialogTableVisible: {
//     get () {
//         return this.visible
//     },
//     set (val) {
//         console.log(val)
//         this.$emit('update:visible', val) // dialogTableVisible改变的时候通知父组件
//     }
//     }
// },
    dataFormat: function (row, column) {
            let data = row[column.property]
        if (data === null) {
            return ''
        }
        let dt = new Date(data)
        // console.log("dt"+dt);
            return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate() + ' ' + dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds()
        },
    handleSizeChange (size) { // pageSize改变时触发
        this.pagesize = size
    },
    handleCurrentPage (currentPage) { // 当前页面改变时触发
        this.currentPage = currentPage
    },
    async getShopIdList () { // 获取店铺列表
      // eslint-disable-next-line no-unused-vars
    const getShopNameData = {
        pageNum: 1,
        pageSize: 50,
        userName: window.sessionStorage.getItem('username')
    }
    // console.log(getShopNameData)
    // console.log(window.sessionStorage.getItem('username'))
    const res = await request.getShopNameList(getShopNameData)
    this.shopNameList = res.data.data.content
    },
    async searchList () { // 点击搜索，获取表格数据
    let currentPage = 1
    const res = await request.getBussinessTableList(
        {
          current: currentPage++, // 当前页码
        shopId: this.shopId,
          size: 100, // 每页数据
          status: 5 // 设置默认获取所有订单
        }
    )
       // console.log(res)
    this.tableData = res.data.data
    },
    // 获取地址信息
    async getAddressList () { // 获取地址列表
    let data = {
        pages: this.currentPage,
        limit: this.pageSize
    }
    // console.log(data)
    let addressRes = await request.getAddressList(data)
    this.addressList = addressRes.data.data.list
    // console.log(addressRes.data.data.list)
    },
    async orderStatusChange (row) {
        // console.log(row)
    this.getAddressList()
    const sendData = {
        orderId: row.id,
        shippingId: this.addressList[0].id,
        userId: 5
        // request.getAddressList.addressForm.id
    }
    // console.log(this.addressList[0].id)

    //    console.log(window.sessionStorage.getItem('token'))
      let res = await request.changeBussinessOrderStatus(sendData) // 传给后端id值修改当前订单状态为待收货
    //   console.log(res)
    if (res.data.message === '成功') {
         // this.tableData.status++
        // location.reload()
    }
    },
    async sendAddressId (row) {
        const addressData = {
            id: row.id
        }
        console.log(row)
        const res = await request.getAddressListById(addressData)
        if (res.data.message === '成功') {
        location.reload()
    }
    }
},
created () {
    this.getShopIdList() // 组件创建获取店铺名列表
    this.sendAddressId()
}
}
</script>

<style scoped>
.search{
margin-bottom: 30px;
}
.address-list{
    width: 100%;
    margin-top: 20px;
}
</style>
